import type { ImageInformation } from 'stores/express-designer';

export function getActiveImageId(images: ImageInformation[], id?: string): string | undefined {
  return images.some(img => img.uuid === id) ? id : images[0]?.uuid;
}
